import { SET_EMBED_PARAMS } from 'client/constants/actions';
import { EmbedStoryParams } from 'src/sdk';

export function setEmbedParams(payload: EmbedStoryParams) {
	return {
		type: SET_EMBED_PARAMS,
		payload,
	};
}
